module.exports = __webpack_public_path__ + "assets/9f0c96dbe204216bb4e8f3da7ffb6891.mp3";